export default {
  title: 'Grupos',
  name_placeholder: 'Nome do grupo',
  create: 'Criar',
  devices_count: '{count} dispositivo | {count} dispositivos',
  assign_aria: 'Atribuir dispositivos ao grupo {name}',
  rename_aria: 'Renomear grupo {name}',
  delete_aria: 'Excluir grupo {name}',
  delete_confirm: 'Excluir o grupo "{name}"? Os dispositivos continuam existindo.',
  group_devices: 'Dispositivos do grupo',
}
